import { RefObject, createRef } from 'react'

import { create } from 'zustand'

import { DropDownFilterState } from '../components/filterBottomSheet/dropDownFilterBottomSheet'
import {
  SubFilterData,
  SubFiltersBSRef,
} from '../components/filterBottomSheet/subFiltersBottomSheet'

type FilterTypes = 'DROPDOWN' | 'SUB_FILTER' | 'QUICK_FILTER'

type CumulativeSelectedFilters = {
  [key in FilterTypes]: DropDownFilterState | SubFilterData
}

interface VariantListingStoreState {
  subFilterRef: RefObject<SubFiltersBSRef | null>
  showPayout: boolean

  initialCategoryId?: string | number
  categoryId?: string | number

  showVariants: boolean
  selectedFiltersTransformed: Record<string, string | number>
  setCategoryId: (categoryId: number | string) => void
  setPayoutVisibility: (showPayout: boolean) => void
  removeFilterBarState: () => void
}

function flattenObject(obj: Record<string, string | Array<string> | object>) {
  const flattened = {}

  function flattenHelper(obj: Record<string, any>, prefix = '') {
    for (const key in obj) {
      if (
        Array.isArray(obj[key]) &&
        obj[key]?.every((item) => typeof item === 'string')
      ) {
        flattened[key] = obj[key].join(',')
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        flattenHelper(obj[key], key)
      } else {
        flattened[key] = obj[key]
      }
    }
  }

  flattenHelper(obj)
  return flattened
}

const subFilterRef = createRef<SubFiltersBSRef | null>()

const initialFilters = {}

const useVariantListingStore = create<VariantListingStoreState>((set) => ({
  subFilterRef,

  showPayout: true,
  setPayoutVisibility: (showPayout) =>
    set(() => ({
      showPayout,
    })),

  initialCategoryId: undefined,
  categoryId: undefined,

  setCategoryId: (categoryId) =>
    set(() => {
      const updatedSelectedFilters = {
        categoryId,
      }
      return {
        categoryId,
        selectedFiltersTransformed: flattenObject(updatedSelectedFilters),
      }
    }),

  showVariants: false,
  selectedFiltersTransformed: initialFilters,

  removeFilterBarState: () => {
    set(() => ({
      showVariants: false,
      selectedFiltersTransformed: {},
    }))
  },
}))

export default useVariantListingStore
